export var actionTypes;
(function (actionTypes) {
    actionTypes["VALIDATION_SUCCESS"] = "VALIDATION_SUCCESS";
    actionTypes["VALIDATION_ERROR"] = "VALIDATION_ERROR";
})(actionTypes || (actionTypes = {}));
